import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';

import { logoutUserRequest } from '@redux/actions/AuthActions';
import { MenuItems } from '@utils/constants';
import { Topbar } from './components';

const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 100,
    height: '100%'
  },
  shiftContent: {
    padding: '100px 0px'
  },
  content: {
    height: '100%'
  }
}));

const Main = (props) => {
  const { children } = props;

  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });

  const dispatch = useDispatch();
  const user = useSelector(
    (state) =>
      state &&
      state.authReducer &&
      state.authReducer.payload &&
      state.authReducer.payload.data &&
      state.authReducer.payload.data.user_id
  );

  const onSidebarOpen = () => {
    dispatch(logoutUserRequest(user));
  };

  return (
    <div
      className={clsx({
        [classes.root]: true,
        [classes.shiftContent]: isDesktop
      })}>
      {/* <Topbar items={MenuItems} onSidebarOpen={onSidebarOpen} /> */}
      {/* <main className={classes.content}>{children}</main> */}
      {children}
    </div>
  );
};

Main.propTypes = {
  children: PropTypes.node.isRequired
};

export default Main;
